import TopBar from '../../components/Layout/TopBar';
import { ClipLoader } from 'react-spinners';
import MyForm from '../../components/Layout/MyForm';
import MyButton from '../../components/Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import useAuthz from '../../hooks/useAuthz';
import { useNavigate } from 'react-router';
import { useAlert } from 'react-alert';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../../components/Utils/FormatData';

const style = {
  container: { height: 'calc(100% - 50px)' },
  formContainer: { width: '50%', margin: '20px' },
  formContent: { flexDirection: 'row' },
  rowActions: { width: '100%', margin: '20px', height: 'auto' },
  inputForm: { width: '90%', margin: '20px' },
};

const formElementPatrimoine = [
  {
    id: 'raison_sociale',
    name: 'raison_sociale',
    label: 'RAISON SOCIALE',
    type: 'text',
    required: true,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'num_tva',
    name: 'num_tva',
    label: 'N° TVA',
    type: 'text',
    required: true,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'num_sap',
    name: 'num_sap',
    label: 'N° SAP',
    type: 'text',
    required: true,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'num_sap_subsidiary',
    name: 'num_sap_subsidiary',
    label: 'N° SAP FILIALE',
    type: 'text',
    required: false,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'num_siren',
    name: 'num_siren',
    label: 'N° SIREN',
    type: 'text',
    required: false,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'email',
    name: 'email',
    label: 'EMAIL COMPTABILITÉ',
    type: 'text',
    required: false,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'telephone1',
    name: 'telephone1',
    label: 'TÉlÉPHONE 1',
    type: 'text',
    required: false,
    readOnly: false,
    style: style.inputForm,
  }, {
    id: 'telephone2',
    name: 'telephone2',
    label: 'TÉlÉPHONE 1',
    type: 'text',
    required: false,
    readOnly: false,
    style: style.inputForm,
  }
];

const CreateOrEditBilledThirdParty = (props) => {
  const element_id = new URLSearchParams(location.search).get('id');
  const [isLoading, setIsLoading] = useState(true);
  const routeBilledThirdParties = '/panneau-administration/tiers-factures';
  const [authz, user, profil] = useAuthz();
  const navigate = useNavigate();
  const alert = useAlert();
  const [billedThirdParty, setBilledThirdParty] = useState({
    raison_sociale: null,
    num_tva: null,
    num_sap: null,
    num_sap_subsidiary: null,
    num_siren: null,
    email: null,
    telephone1: null,
    telephone2: null,
  });

  //#region useEffect

  useEffect(() => {
    if (profil.profil === 1) {
      if (element_id) {
        document.title = 'TE - Edition d\'un tiers facturé';
        apiLoadBilledThirdParty();
      } else {
        document.title = 'TE - Création d\'un tiers facturé';
      }
      setIsLoading(false);
    } else {
      alert.error('Vous n\'êtes pas autorisé à accéder à ce module');
      navigate(routeBilledThirdParties);
    }
  }, []);

  //#endregion

  //#region Fonctions

  const handleValid = () => {
    if (billedThirdParty.raison_sociale === null || billedThirdParty.raison_sociale === '') {
      alert.error('La raison sociale est obligatoire');
      return;
    }

    if (billedThirdParty.num_tva === null || billedThirdParty.num_tva === '') {
      alert.error('Le numéro de TVA est obligatoire');
      return;
    }

    if (billedThirdParty.num_sap === null || billedThirdParty.num_sap === '') {
      alert.error('Le numéro SAP est obligatoire');
      return;
    }

    createOrEditBilledThirdParty();
  };
  const handleChangeValue = (event) => {
    if (event?.target) {
      setBilledThirdParty({ ...billedThirdParty, [event.target.name]: event.target.value });
    } else {
      setBilledThirdParty({ ...billedThirdParty, dtPose: event });
    }
  };

  //#endregion

  // region API
  const apiLoadBilledThirdParty = () => {
    axios({
      method: 'get',
      url: `${URL_API}/billed-third-party/get-by-id`,
      params: {
        id: element_id
      },
    })
      .then((response) => {
        alert.removeAll();

        if (response.data) {
          setBilledThirdParty(response.data);
        }

      })
      .catch((error) => {
        logError(alert, error);
      });
  }

  const createOrEditBilledThirdParty = () => {
    axios({
      method: 'post',
      url: `${URL_API}/billed-third-party/create-or-edit`,
      data: billedThirdParty,
      params: { userAction: user.user_id },
    })
      .then(() => {
        alert.removeAll();
        if (billedThirdParty.id !== null) {
          alert.success(`Le tier facturé a été édité avec succés`);
        } else {
          alert.success(`Le tier facturé a été créé avec succés`);
        }
        navigate(routeBilledThirdParties);
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  //#endregion

  return (<div style={{ height: '100%' }}>
    <TopBar title={element_id ? 'Édition d\'un tiers facturé' : 'Création d\'un tier facturé'} className='topbar-contenu'
            color={props.params.color}
            buttons={null} />

    <div className='row' style={{ ...style.container, alignItems: isLoading ? 'center' : '', overflow: 'auto' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading &&
        (
          <>
            <div className='form-content-center' style={style.formContent}>
              <div style={style.formContainer}>
                <MyForm data={billedThirdParty} variant={'outlined'} setData={setBilledThirdParty}
                        form={formElementPatrimoine} onChange={handleChangeValue} />
              </div>
            </div>

            <div className='row' style={style.rowActions}>
              <MyButton onClick={() => navigate(routeBilledThirdParties)} style={'buttonDefault'} label={'Annuler'}
                        icon={faXmark} />
              <MyButton onClick={handleValid} style={'buttonValidation'} label={'Valider'} icon={faCheck} />
            </div>
          </>
        )
      }
    </div>
  </div>);
};

export default CreateOrEditBilledThirdParty;